import React from 'react';
import Header from './Header';

interface LayoutProps {}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <React.Fragment>
            <Header />
            <div className='flex flex-col mt-5 sm:mt-10 pb-8'>
                <div className='main container mx-auto px-4'>{children}</div>
            </div>
        </React.Fragment>
    );
};

export default Layout;
